import { lighten } from "polished";
import styled from "styled-components";

export const StyledLangIconWrapper = styled.div<{ height: number }>`
  height: ${({ height }) => `${height}px`};
`;

export const StyledLangIcon = styled.span`
  position: relative;
  font-size: inherit;
`;

export const StyledLangItem = styled.div`
  width: 160px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &.selected {
    background-color: ${({ theme }) =>
      lighten(0.005, theme.palette.background.default)};
  }

  & h4 {
    margin-left: 5px;
    margin-bottom: 0;
    font-weight: ${({ theme }) => theme.font.weight.medium};
    font-size: ${({ theme }) => theme.font.size.base};

    [dir="rtl"] & {
      margin-left: 0;
      margin-right: 16px;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
      font-size: ${({ theme }) => theme.font.size.lg};
    }
  }
`;
